export default __webpack_public_path__ + "static/media/IMG-20210326-WA0028.ff095848.jpg";